import React from 'react'
import Operation from '@common/Operation'
import store from '../store'
import { NOTICE_VERIFYING, NOTICE_PASSED, NOTICE_REJECTED } from '@constant'

const Item = Operation.Item

export default [
  {
    title: '公告信息',
    dataIndex: 'content',
    key: 'content',
    width: 450
  },
  {
    title: '状态',
    dataIndex: '',
    key: 'status',
    width: 130,
    render: ({ status, reason }) => {
      const statusText = {
        [NOTICE_VERIFYING]: <span>审核中</span>,
        [NOTICE_PASSED]: <span style={{ color: '#2fc286' }}>审核通过</span>,
        [NOTICE_REJECTED]: (
          <div>
            <p style={{ color: '#ff5c5c' }}>审核不通过</p>
            <span>原因：{reason}</span>
          </div>
        )
      }
      return statusText[+status]
    }
  },
  {
    title: '发布时间',
    dataIndex: 'updated_at',
    key: 'updated_at',
    width: 180
  },
  {
    title: '操作',
    dataIndex: '',
    key: 'operation',
    width: 120,
    render: ({ content }) => {
      return (
        <Operation separator="">
          <Item onClick={store.showModal(content)}>编辑</Item>
          <Item onClick={store.delNotice} style={{ color: '#ff5c5c' }}>
            删除
          </Item>
        </Operation>
      )
    }
  }
]
